export const skillsData = [
    'JavaScript',
    'React',
    'Node JS',
    'Express JS',
    'Ruby',
    'Python',
    'MySQL',
    'MongoDB',
    'HTML',
    'CSS',
    'Tailwind',
    'Git',
    'Firebase'
];
